const FIT_FINDER = 40;
const LAST_SEEN = -62;
const PRODUCT_SERIES = -29;
const SHOP_THE_LOOK = -35;
const OUTFITS = -32;

export default {
    FIT_FINDER,
    LAST_SEEN,
    PRODUCT_SERIES,
    SHOP_THE_LOOK,
    OUTFITS
}